// extracted by mini-css-extract-plugin
export default {"wrapper":"Ss-z","response":"Ts-z","error":"Us-z","disabled":"Vs-z","buttons":"Ws-z","feedbackQuestionSection":"Xs-z","yesNoWrapper":"Ys-z"};